export const referalLang = {
    statistic: {
        'en': 'REFERRAL STATISTIC',
        'fr': 'STATISTIQUE DE PARRAINAGE',
        'de': 'EMPFEHLUNGSSTATISTIK',
        'ko': '추천 통계',
        'ch': '推荐统计',
        'ru': 'РЕФЕРАЛЬНАЯ СТАТИСТИКА',
        'it': 'STATISTICHE DI RIFERIMENTO',
        'jap': '紹介データの統計',
        'port': 'ESTATÍSTICA DE REFERÊNCIA',
        'turk': 'TAVSİYE İSTATİSTİKLERİ',
        'viet': 'THỐNG KÊ GIỚI THIỆU',
        'spa': 'ESTADÍSITICAS DE REFERIDOS',
        'arab': 'إحصائيات الإحالة'
    },
    guest: {
        'en': 'MY GUESTS',
        'fr': 'MES INVITÉS',
        'de': 'MEINE GÄSTE',
        'ko': '내 게스트',
        'ch': '我的访客',
        'ru': 'МОИ ГОСТИ',
        'it': 'I MIEI OSPITI',
        'jap': 'Myゲスト',
        'port': 'MEUS CONVIDADOS',
        'turk': 'KONUKLARIM',
        'viet': 'KHÁCH CỦA TÔI',
        'spa': 'MIS INVITADOS',
        'arab': 'ضيوفي'
    },
    reflink: {
        'en': 'My Referral links',
        'fr': 'Mes liens de parrainage',
        'de': 'Meine Empfehlungslinks',
        'ko': '내 추천 링크',
        'ch': '我的推荐链接',
        'ru': 'Мои реферальные ссылки',
        'it': 'I miei link di Riferimento',
        'jap': 'My紹介リンク',
        'port': 'Meus links de referência',
        'turk': 'Tavsiye bağlantılarım',
        'viet': 'Các liên kết giới thiệu của tôi',
        'spa': 'Mis enlaces de refereridos',
        'arab': 'روابط الإحالة الخاصة بي'
    },
    copy: {
        'en': 'Copied.',
        'fr': 'Copié.',
        'de': 'Kopiert.',
        'ko': '복사되었습니다.',
        'ch': '已复制。',
        'ru': 'СКОПИРОВАНО',
        'it': 'Copiato.',
        'jap': 'コピーしました。',
        'port': 'Copiado.',
        'turk': 'Kopyalandı.',
        'viet': 'Đã sao chép.',
        'spa': 'Copiado.',
        'arab': 'نسخ.'
    },
    copy2: {
        'en': 'COPY',
        'fr': 'COPIER',
        'de': 'KOPIEREN',
        'ko': '복사',
        'ch': '复制',
        'ru': 'СКОПИРОВАТЬ',
        'it': 'COPIA',
        'jap': 'コピー',
        'port': 'COPIAR',
        'turk': 'KOPYALA',
        'viet': 'SAO CHÉP',
        'spa': 'COPIAR',
        'arab': 'نسخ'
    },
    info: {
        'en': 'Receive payments in the amount of 5% of the amount attracted by the referral',
        'fr': 'Recevez des paiements dun montant de 5 % du montant attiré par le parrainage',
        'de': 'Erhalten Sie Zahlungen in Höhe von 5 % des durch die Empfehlung generierten Betrags',
        'ko': '추천인이 유치한 금액의 5%만큼 지급금을 받습니다.',
        'ch': '收到的金额为推荐所吸引金额的 5%',
        'ru': 'Получайте выплаты в размере 5% от суммы, привлеченной рефералом',
        'it': 'Ricevi pagamenti per un importo pari al 5% dell`importo attirato dal riferimento',
        'jap': '紹介した相手が登録すると、紹介相手の入金額の5%を受け取ることができます',
        'port': 'Receba pagamentos no valor de 5% do valor atraído pela indicação',
        'turk': 'Tavsiye ile getirilen tutarın %5`ine kadar miktarda ödeme alın',
        'viet': 'Nhận thanh toán 5% số tiền mà người giới thiệu nhận được',
        'spa': 'Recibe pagos por un importe del 5% de la cantidad atraída por el referido',
        'arab': 'تلقي دفوعات بقيمة 5٪ من المبلغ الذي تجتذبه الإحالة'
    },
    attention: {
        'en': 'ATTENTION!',
        'fr': 'ATTENTION!',
        'de': 'HINWEIS!',
        'ko': '주의!',
        'ch': '注意！',
        'ru': 'ВНИМАНИЕ!',
        'it': 'ATTENZIONE!',
        'jap': '警告！',
        'port': 'ATENÇÃO!',
        'turk': 'DİKKAT!',
        'viet': 'CHÚ Ý!',
        'spa': '¡ATENCIÓN!',
        'arab': 'انتباه!'
    },
    attention2: {
        'en': 'To use the referral program, you need to fill in the "Nickname" field in the Personal information section.',
        'fr': 'Pour utiliser le programme de parrainage, vous devez remplir le champ «Pseudo » dans la section des',
        'de': 'Um das Empfehlungsprogramm nutzen zu können, müssen Sie das Feld „Spitzname“ im Abschnitt',
        'ko': '추천 프로그램을 사용하려면 개인 정보 섹션의',
        'ch': '要使用推荐计划，您需要在个人信息部分填写',
        'ru': 'Для использования реферальной программы Вам необходимо заполнить поле «Никнейм» в разделе',
        'it': 'Per utilizzare il programma di riferimento devi riempire il campo "Soprannome" nella sezione delle informazioni personali.',
        'jap': '紹介プログラムを利用するには、個人情報ページの「ニックネーム」欄に入力する必要があります。',
        'port': 'Para usar o programa de referência, você precisa preencher o campo "Apelido" na seção de informações pessoais.',
        'turk': 'Tavsiye programını kullanmak için Kişisel bilgiler bölümündeki "TakmaAd" alanını doldurmanız gerekmektedir.',
        'viet': 'Để sử dụng chương trình giới thiệu, bạn cần điền vào trường "Tên hiệu" trong mục thông tin cá nhân.',
        'spa': 'Para utilizar el programa de recomendación, tienes que rellenar el campo "NickName" (Nombre de alias) en la sección de información personal.',
        'arab': ' لاستخدام برنامج الإحالة، تحتاج إلى ملء حقل "الاسم المستعار" في قسم المعلومات الشخصية.'
    },
    attention3: {
        'en': 'Personal information',
        'fr': 'informations personnelles',
        'de': '„Persönliche Informationen“',
        'ko': '닉네임',
        'ch': '“昵称”',
        'ru': '«Личные данные»',
        'it': 'Informazioni personali',
        'jap': '個人情報',
        'port': 'Informacao',
        'turk': 'Kişisel bilgiler',
        'viet': 'Thông tin cá nhân',
        'spa': 'Información Personal',
        'arab': 'المعلومات الشخصية'
    },
    attention4: {
        'en': 'section.',
        'fr': 'section.',
        'de': 'ausfüllen.',
        'ko': '필드를 입력해야 합니다.',
        'ch': '字段。',
        'ru': 'секция.',
        'it': 'sezione.',
        'jap': 'セクション。',
        'port': 'seccao.',
        'turk': 'bölüm.',
        'viet': 'phần.',
        'spa': 'apartado.',
        'arab': 'القسم.'
    },
    refgroup: {
        'en': 'My Referral group',
        'fr': 'Mon groupe de parrainage',
        'de': 'Meine Empfehlungsgruppe',
        'ko': '내 추천 그룹',
        'ch': '我的推荐组',
        'ru': 'Моя реферальная группа',
        'it': 'Il mio gruppo di riferimento',
        'jap': 'My紹介グループ',
        'port': 'Meu grupo de referência',
        'turk': 'Tavsiye grubum',
        'viet': 'Nhóm giới thiệu của tôi',
        'spa': 'Mi grupo de referidos',
        'arab': 'مجموعة الإحالة الخاصة بي'
    },
    amount: {
        'en': 'Amount $',
        'fr': 'Montant en $',
        'de': 'Betrag $',
        'ko': '금액 $',
        'ch': '金额 ($)',
        'ru': 'Количество $',
        'it': 'Quantità di $',
        'jap': '金額 $',
        'port': 'Valor $',
        'turk': 'Tutar $',
        'viet': 'Lượng $',
        'spa': 'Importe en $',
        'arab': 'المبلغ $'
    },
    amount_coin: {
        'en': 'Amount Coin',
        'fr': 'Montant en cryptomonnaie',
        'de': 'Anzahl Coin',
        'ko': '코인 수량',
        'ch': '币数',
        'ru': 'Количество Монет',
        'it': 'Quantità di Moneta',
        'jap': 'コインの金額',
        'port': 'Quantidade de moedas',
        'turk': 'Coin Miktarı',
        'viet': 'Số coin',
        'spa': 'Número de monedas',
        'arab': 'المبلغ بالعملة'
    },
    package: {
        'en': 'Package',
        'fr': 'Forfait',
        'de': 'Paket',
        'ko': '패키지',
        'ch': '套餐',
        'ru': 'Пакет',
        'it': 'Pacchetto',
        'jap': 'パッケージ',
        'port': 'Pacote',
        'turk': 'Paket',
        'viet': 'Gói',
        'spa': 'Paquete',
        'arab': 'الحزمة '
    },
    status: {
        'en': 'Status',
        'fr': 'Statut',
        'de': 'Status',
        'ko': '상태',
        'ch': '状态',
        'ru': 'Статус',
        'it': 'Stato',
        'jap': 'ステータス',
        'port': 'Status',
        'turk': 'Durum',
        'viet': 'Trạng thái',
        'spa': 'Estado',
        'arab': 'حالة'
    },
    time: {
        'en': 'Time',
        'fr': 'Durée',
        'de': 'Zeit',
        'ko': '시간',
        'ch': '时间',
        'ru': 'Время',
        'it': 'Ora',
        'jap': '時間',
        'port': 'Tempo',
        'turk': 'Zaman',
        'viet': 'Thời gian',
        'spa': 'Hora',
        'arab': 'وقت'
    },
    unavailable: {
        'en': 'link is temporarily unavailable',
        'fr': 'le lien est momentanément indisponible',
        'de': 'Link ist vorübergehend nicht verfügbar',
        'ko': '링크를 일시적으로 사용할 수 없습니다',
        'ch': '链接暂时不可用',
        'ru': 'ссылка временно недоступна',
        'it': 'il link non è al momento disponibile',
        'jap': 'リンクは一時的に使用できません',
        'port': 'o link está temporariamente indisponível',
        'turk': 'Bağlantı geçici olarak kullanılamıyor',
        'viet': 'liên kết tạm thời không sẵn có',
        'spa': 'el enlace no está disponible temporalmente',
        'arab': 'الرابط غير متوفر مؤقتًا'
    },
}